// src/app/materials-grid/materials-grid.component.ts
import { Component, OnInit } from '@angular/core';
import { Materials } from '../../../Materials';
import { MaterialsService } from '../Services/materials.service';

import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-materials-grid',
  templateUrl: './materials-grid.component.html',
  styleUrls: ['./materials-grid.component.css'],
})
export class MaterialsGridComponent implements OnInit {
  NotMobile:boolean =false;
  items: any[] = [];
  materials: Materials[] = [];
  pageOfItems?: Array<any>;
  sortProperty: string = 'id';
  sortOrder = 1;
  loading = false;
  filteredData: Materials[]= [];
  selectedFile: File | null = null;

  constructor(
    private materialsService: MaterialsService,
    public router: Router
  ) { }

  ngOnInit() {
    this.loadMaterials();
    this.checkisMobile();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    this.filteredData = this.materials.filter(item => {
      return Object.values(item).some(val => 
        String(val).toLowerCase().includes(filterValue)
      );
    });
  }
  loadMaterials() {
    this.materialsService.GetMaterials().subscribe((materials) => {
      this.materials = materials;

 
      this.filteredData = materials
      console.log(materials);
      
    });
  }

  editMaterial(material: Materials) {
    // Implement the edit functionality here
    
    this.router.navigate(['materials/edit/', material.id]);
    // You can open a dialog or navigate to a separate edit page with the material's data
    console.log('Editing material:', material);
  }

  sortBy(property: string) {
     
    this.sortOrder = property === this.sortProperty ? (this.sortOrder * -1) : 1;
    this.sortProperty = property;
    this.items = [...this.materials.sort((a: any, b: any) => {
        // sort comparison function
        let result = 0;
        if (a[property] < b[property]) {
            result = -1;
        }
        if (a[property] > b[property]) {
            result = 1;
        }
        return result * this.sortOrder;
    })];
}
checkisMobile() { 
     
  const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

  if(width < 768)
  {this.NotMobile = false;
  }
    else
  {this.NotMobile = true;}
  
  
}
sortIcon(property: string) {
    if (property === this.sortProperty) {
        return this.sortOrder === 1 ? '☝️' : '👇';
    }
    return '';
}

onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    this.selectedFile = input.files && input.files.length ? input.files[0] : null;
  }

  // download a small sample CSV users can edit and re-upload
  downloadSampleCsv() {
    const sampleLines = [
      'Product Name,Product Category,Sub Category,Product Description,Product Price,Product Weight,Units,Total',
      'Brick,Masonry,Clay,Standard red brick,0.50,0.65,100,50',
      'Cement,Materials,Portland,Type I/II cement,7.25,50,1,7.25',
      'Lumber,Finish,Oak,2x4 oak board,5.75,8,10,57.50'
    ];
    const sample = sampleLines.join('\r\n');
    const blob = new Blob([sample], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'materials-sample.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }
  uploadCsv() {
    if (!this.selectedFile) { return; }

    const reader = new FileReader();
    reader.onload = async (e) => {
      const text = (e.target?.result || '') as string;
      const rows = this.parseCsv(text);
      if (!rows.length) {
        alert('No rows found in CSV.');
        return;
      }
      if (!confirm(`Import ${rows.length} materials?`)) { return; }

      let success = 0;
      let failed = 0;

      // sequentially call service to avoid API rate bursts — you can change to parallel if desired
      for (const item of rows) {
        try {
          // materialService.addMaterial should return Observable<Material> — adapt if different
          // using toPromise for simpler flow (or subscribe)
          // tslint:disable-next-line: deprecation
          await this.materialsService.addMaterial(item).toPromise();
          success++;
        } catch (err) {
          console.error('Failed to import row', item, err);
          failed++;
        }
      }

      alert(`Import finished. Success: ${success}, Failed: ${failed}`);
      this.selectedFile = null;
      // reload data after import
      this.loadMaterials?.(); // call your existing load method (adjust name if different)
    };
    reader.readAsText(this.selectedFile);
  }

  private parseCsv(text: string): Materials[] {
    const lines = text.split(/\r?\n/).map(l => l.trim()).filter(l => l.length);
    if (!lines.length) { return []; }

    const header = lines[0].split(',').map(h => h.trim().toLowerCase());
    const mapHeaderToKey = (h: string) => {
      // map common header names to your material object keys
      if (/(product.?name|name)/.test(h)) return 'productName';
      if (/(product.?category|category)/.test(h)) return 'productCategory';
      if (/(sub.?category|subcategory)/.test(h)) return 'subCategory';
      if (/(product.?description|description|desc)/.test(h)) return 'productDescription';
      if (/(product.?price|price)/.test(h)) return 'productPrice';
      if (/(product.?weight|weight)/.test(h)) return 'productWeight';
      if (/(units?)/.test(h)) return 'units';
      if (/(total)/.test(h)) return 'total';
      return h; // fallback: keep header as key
    };

    const keys = header.map(h => mapHeaderToKey(h));

    const items: Materials[] = [];
    for (let i = 1; i < lines.length; i++) {
      const cols = lines[i].split(',').map(c => c.trim());
      if (cols.length === 0) { continue; }
      const obj: any = {};
      for (let j = 0; j < keys.length; j++) {
        const key = keys[j];
        const val = cols[j] ?? '';
        if (!key) { continue; }
        // parse numeric columns
        if (['productPrice', 'productWeight', 'total'].includes(key)) {
          const num = parseFloat(val.replace(/[^0-9.\-]/g, '')) || 0;
          obj[key] = num;
        } else {
          obj[key] = val;
        }
      }
      items.push(obj as Materials);
    }
    return items;
  }
}
